import { Component, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

export type ToggleSize = 'sm' | 'md';

@Component({
    selector: 'app-toggle-switch',
    templateUrl: './toggle-switch.component.html',
    styleUrls: ['./toggle-switch.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ToggleSwitchComponent),
            multi: true,
        },
    ],
})
export class ToggleSwitchComponent implements ControlValueAccessor {
    @Input() color: string = '#2E2D83';
    @Input() size: ToggleSize = 'md'; 

    checked = false;
    disabled = false;

    private onChange = (value: any) => {};
    private onTouched = () => {};

    // Métodos del ControlValueAccessor
    writeValue(value: any): void {
        this.checked = [1, true, 'Si', 'Sí', 'si', 'SI'].includes(value);
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    toggle(event: Event) {
        if (this.disabled) return;
        const target = event.target as HTMLInputElement;
        this.checked = target.checked;
        this.onChange(this.checked ? 1 : 0); // devolvemos 1 o 0
        this.onTouched();
    }
}
